import { themeGet } from '@styled-system/theme-get';
import { Select } from 'antd';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { IOptionItem } from '../../../components/Dropdown/IOptionItem';
import { IHybridResponse } from '../../../logic/Models/Responses/SeedResponse';

const StyledSelect = styled(Select)`
	width: 100%;
	.ant-select-selector {
		border-radius: 4px !important;
		border-color: ${themeGet('colors.darkGrey')} !important;
		//background-color: ${themeGet('colors.darkGrey')} !important;
		//color: white;
		font-family: 'Roboto';
		font-size: ${themeGet('fontSizes.small')};
		font-weight: ${themeGet('fontWeights.bold')};
	}

	svg path {
		fill: ${themeGet('colors.darkGrey')};
		stroke: ${themeGet('colors.darkGrey')};
		stroke-width: 100;
	}
`;

export interface IPpgPickSeedRowProps
{
	disableAllSeeds: boolean;
	seedList:  IHybridResponse[];
	selectedSeeds: IHybridResponse[];
	selectSeed: (value: string) => void;
}

export const PpgPickSeedRow = ({ 
	disableAllSeeds, 
	seedList = [], 
	selectedSeeds = [], 
	selectSeed 
}: IPpgPickSeedRowProps) =>
{
	// Calculate what agronomic attributes are available for selection.
	const seedOptions = useMemo(() => 
	{
		const options: IOptionItem[] = seedList
			.sort((a, b) => parseFloat(a.RelativeMaturity) - parseFloat(b.RelativeMaturity))
			.map<IOptionItem>(seed =>
			{
				const label = (
					<span style={{ display: 'flex', fontWeight: 'bold' }} >
						<span style={{flex: 0.6}}>{seed.Name}</span>
						<span style={{flex: 0.4}}>
							RM:&nbsp; 
							<span style={{ fontWeight: 'normal' }}>
								{seed.RelativeMaturity}
							</span>
						</span>
					</span>
				);

				return {
					label, 
					value: seed.Id, 
					searchValue: `${seed.Name} ${seed.RelativeMaturity}`,
					disabled: disableAllSeeds 
						|| selectedSeeds.some(s => s.Id === seed.Id),
				};
			});
		
		return options;
	}, [seedList, selectedSeeds, disableAllSeeds]);

	return (
		<div style={{ width: '100%', marginBottom: 10 }}>
			<div style={{ width: '90%' }}>
				<StyledSelect
					showSearch
					optionFilterProp='label'
					options={seedOptions}
					onSelect={selectSeed}
					value={null} // Keeps the value cleared after a selection
					placeholder={'Select a Seed'}
					filterOption={(input, option) =>
					{
						return (option?.searchValue ?? '').toLowerCase().includes(input.toLowerCase());
					}}
				/>
			</div>
		</div>
	);
};